export default __webpack_public_path__ + "271ad8934f41170dc1d7558db545ffba.png";